import React from 'react';
import type { WorkoutPlanPayload } from '../../../../data-access/api/science/openapi/api';
import '../richContext.scss';

type WorkoutPlanExercise = NonNullable<WorkoutPlanPayload['exercises']>[number];

type Props = {
  exercises: WorkoutPlanExercise[];
};

const OtherWorkoutPlanContent: React.FC<Props> = ({ exercises }) => {
  const notes = exercises
    .map((ex) =>
      (ex as any)?.type === 'note' && typeof (ex as any).text === 'string' ? (ex as any).text : null
    )
    .filter((t): t is string => typeof t === 'string' && t.trim().length > 0)
    .map((t) => t.trim());

  const metaCalories = exercises
    .map((ex) => ((ex as any)?.type === 'meta' ? (ex as any).estimated_calories : null))
    .find((v) => typeof v === 'number');

  if (notes.length === 0 && typeof metaCalories !== 'number') return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      {typeof metaCalories === 'number' && (
        <div className="rc-workout-exercise-row">
          <div className="rc-workout-exercise-left">
            <div style={{ flex: 1, minWidth: 0 }}>
              <span className="rc-workout-exercise-note">
                Estimated calories: {Math.round(metaCalories as number)}
              </span>
            </div>
          </div>
        </div>
      )}
      {notes.length > 0 && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          {notes.slice(0, 5).map((text, idx) => (
            <div key={`note_${idx}`} className="rc-workout-exercise-row">
              <div className="rc-workout-exercise-left">
                <div style={{ flex: 1, minWidth: 0 }}>
                  <span className="rc-workout-exercise-note">{text}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default OtherWorkoutPlanContent;
